export const oneTimeCodePattern = /^\d{6}$/;
